var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyetherwallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "37px",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav-bar-white",
    transform: "translate(-3.000000, -3.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MEW-logo",
    transform: "translate(3.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 17.9090909,
    cy: 18.6060606,
    r: 15.3333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6063781,0.484848485 C8.59819854,0.484848485 0.484848485,8.59819854 0.484848485,18.6063781 C0.484848485,28.6145577 8.59819854,36.7272727 18.6063781,36.7272727 C28.6145577,36.7272727 36.7272727,28.6145577 36.7272727,18.6063781 C36.7272727,8.59819854 28.6145577,0.484848485 18.6063781,0.484848485 M18.4640397,30.8984045 C12.615417,30.8984045 7.60101266,25.9062386 7.60101266,19.7485319 C7.60101266,18.3027762 7.86231217,16.6336145 8.33762265,15.3659452 L13.0058506,17.4589399 C12.990694,17.5272383 12.9712936,17.6166007 12.9500744,17.7187292 C12.8112192,18.1981048 12.7297541,18.6938576 12.707569,19.1944851 C12.6977463,19.2937023 12.694303,19.3935048 12.6972625,19.4932108 C12.6972625,19.5161897 12.7002939,19.5385303 12.7015064,19.5615092 C12.7228262,21.3911514 13.5313214,23.1118349 14.8997174,24.2398611 C16.2681134,25.3678874 18.0486599,25.7814598 19.7408304,25.3643196 L22.3938389,30.1069091 C21.1449095,30.6314843 19.812322,30.9001276 18.4676773,30.8984045 M16.5317069,18.405694 L24.6351046,18.3683115 C24.3453973,15.2784811 21.324164,12.7704577 18.4749445,12.7704577 C17.8286364,12.7696374 17.18673,12.8821983 16.5756803,13.1035015 L13.7710809,8.09561091 C15.2465633,7.38526688 16.8507508,7.0186969 18.4736511,7.02103504 C24.7120581,7.02103504 30.0431897,12.4346953 30.0431897,18.9915791 C30.0431897,20.7587501 29.8259092,22.525921 29.1663078,24.0327741 L16.5317069,18.405694 Z",
    id: "Shape",
    fill: "#1896A4"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyetherwallet);
export default __webpack_public_path__ + "static/media/myetherwallet.5719030acff1aa2607ad6122c9285642.svg";
export { ForwardRef as ReactComponent };